module.exports = __webpack_public_path__ + "/static/assets/99a54173c70c53b8cbe6efe400fb87c8.png";